import {clickDropdownContainer} from './DropdownMenu/Handler';
import {timeElementClickedHandler} from '../Library/Time';

export const handleNotificationRead = (event) => {
    document.querySelectorAll('.notification-badge').forEach(badge => {
        const currentCount = parseInt(badge.textContent, 10) || 0;
        badge.textContent = currentCount > 1 ? String(currentCount - 1) : '';
    });

    const id = event?.detail?.id ?? event?.target?.dataset?.notificationId;

    if (!id) {
        return;
    }

    document.querySelector(`.notification-popup-item[data-notification-id="${id}"]`)?.remove();

    const row = document.querySelector(`#notification-${id}`);

    if (row) {
        row.classList.replace('unread', 'read');
        row.querySelector('button[hx-post]')?.remove();
    }
};

export const handleAllNotificationsRead = () => {
    document.querySelectorAll('.notification-badge').forEach(badge => {
        badge.textContent = '';
    });

    document.querySelectorAll('.notification-popup').forEach(popup => popup.remove());

    document.querySelectorAll('tr.notification-row.unread').forEach(row => {
        row.classList.replace('unread', 'read');
        row.querySelector('button[hx-post]')?.remove();
    });
};

export const handleNotificationBellClick = (container, target) => {
    if (container.querySelector('.notification-popup') === null) {
        window.location.href = container.dataset.notificationUrl;

        return;
    }

    const trigger     = container.querySelector('.dropdown-trigger');
    const isOnTrigger = trigger && (trigger === target || trigger.contains(target));

    if (isOnTrigger) {
        clickDropdownContainer(target, container);

        return;
    }

    if (target.closest('.notification-popup') !== null && target.tagName === 'TIME') {
        timeElementClickedHandler(target);
    }
};
